import { SortArrows } from '@rio-cloud/rio-uikit';

import { SortDirection, SortField } from '../../../utils/sortUtils';

interface IBudgetsTableHeaderProps {
  sortField: SortField | null;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
}

const BudgetsTableHeader = (props: IBudgetsTableHeaderProps) => {
  return (
    <thead>
      <tr>
        <th
          className="user-select-none sort-column cursor-pointer"
          onClick={() => props.onSort('consultantName')}
          style={{ maxWidth: '180px', width: '180px' }}
        >
          <span>
            <SortArrows
              direction={props.sortField === 'consultantName' ? props.sortDirection : undefined}
            />
            <span>Consultor da concessionária</span>
          </span>
        </th>
        <th
          className="user-select-none sort-column cursor-pointer"
          onClick={() => props.onSort('origin')}
          style={{ maxWidth: '200px', width: '200px' }}
        >
          <span>
            <SortArrows
              direction={props.sortField === 'origin' ? props.sortDirection : undefined}
            />
            <span>Origem</span>
          </span>
        </th>
        <th
          className="user-select-none sort-column cursor-pointer"
          onClick={() => props.onSort('recipient')}
        >
          <span>
            <SortArrows
              direction={props.sortField === 'recipient' ? props.sortDirection : undefined}
            />
            <span>Destinatário</span>
          </span>
        </th>
        <th
          className="user-select-none sort-column cursor-pointer"
          onClick={() => props.onSort('user')}
        >
          <span>
            <SortArrows direction={props.sortField === 'user' ? props.sortDirection : undefined} />
            <span>Usuário</span>
          </span>
        </th>
        <th className="user-select-none sort-column">
          <span>
            <SortArrows />
            <span>Orçamento</span>
          </span>
        </th>
        <th
          className="user-select-none sort-column cursor-pointer"
          onClick={() => props.onSort('version')}
          style={{ maxWidth: '80px', width: '80px' }}
        >
          <span>
            <SortArrows
              direction={props.sortField === 'version' ? props.sortDirection : undefined}
            />
            <span>Versão</span>
          </span>
        </th>
        <th
          className="user-select-none sort-column cursor-pointer"
          onClick={() => props.onSort('date')}
        >
          <span>
            <SortArrows direction={props.sortField === 'date' ? props.sortDirection : undefined} />
            <span>Data</span>
          </span>
        </th>
        <th
          className="user-select-none sort-column cursor-pointer"
          onClick={() => props.onSort('status')}
        >
          <span>
            <SortArrows
              direction={props.sortField === 'status' ? props.sortDirection : undefined}
            />
            <span>Status</span>
          </span>
        </th>
        <th className="user-select-none">
          <span>Histórico</span>
        </th>
      </tr>
    </thead>
  );
};

export default BudgetsTableHeader;
